export default __webpack_public_path__ + "static/media/architecture-interior-design.c1136a76.png";